import { TTheme } from 'src/views/account/AccountView/General/types';

export const defaultUserTheme: TTheme = {
    image: '',
    primary: '#333',
    secondary: '#333',
    success: '#333',
    warning: '#333',
    error: '#333',
    textPrimary: '#333',
    textSecondary: '#333',
};
